import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-compliments-and-complaints.component.scss';
var FormItemComplimentsAndComplaints = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemComplimentsAndComplaints, _super);
    function FormItemComplimentsAndComplaints(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = '';
        return _this;
    }
    FormItemComplimentsAndComplaints.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-compliments-and-complaints__button');
        this.isSBCustomer = Array.from(this.element.querySelectorAll("input[name=existing-customer]"));
        this.isSBCustomerValue = 'NO';
        this.NoSelection = Array.from(this.element.querySelectorAll("input[name='permission-for-ID']"));
        this.NoToShare = "";
        this.queryTypeCompliments = this.element.querySelector(".js-form-item-compliments-enquiryType");
        this.feedbackTypeSelect = this.element.querySelector(".js-form-item-compliments-feedback");
        this.feedbackTypeSubSelect = this.element.querySelector(".js-form-item-compliments-feedback-category");
        this.feedbackTypeSubSubSelect = this.element.querySelector(".js-form-item-compliments-feedback-sub-category");
        this.complaintsProcessLinkContainer = this.element.querySelector(".complaints-process-wrapper");
        if (this.queryTypeCompliments) {
            this.updateComplimentsEmail();
            this.displayComplaintsProcess();
            var textAreaMessage = this.element.querySelector("textarea[name=message]");
            if (textAreaMessage) {
                textAreaMessage.setAttribute('maxlength', '500');
            }
        }
        if (this.feedbackTypeSelect) {
            this.populateFeedbackTypeData();
            this.populateFeedBackType();
        }
        if (this.feedbackTypeSubSelect) {
            this.resetSubSelect();
        }
        if (this.feedbackTypeSubSubSelect) {
            this.resetSubSubSelect();
        }
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
            this.displayDeclined = this.form.querySelector(".form-container-complaints__declined");
        }
    };
    FormItemComplimentsAndComplaints.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            _this.businessCashSolutionsValidations();
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                _this.showDisplayView("loader");
                // Check if gRecaptcha is enabled for this form
                if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != '') {
                    var gToken_1 = '';
                    try {
                        // Attempt to get recaptcha token
                        grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var err_1;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                    case 1:
                                        gToken_1 = _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        // Log error
                                        console.log("Unable to retrieve gRecaptcha Token");
                                        console.log(err_1);
                                        return [3 /*break*/, 3];
                                    case 3:
                                        // Set recaptcha token
                                        this.gRecaptchaToken = gToken_1;
                                        this.submitForm(_form);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                    catch (err) {
                        // Log error
                        console.log("Unable to retrieve gRecaptcha Token");
                        console.log(err);
                        _this.submitForm(_form);
                    }
                }
                else {
                    _this.submitForm(_form);
                }
            }
        });
        if (this.isSBCustomer) {
            this.isSBCustomer.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this.isSBCustomerValue = _radio.value;
                });
            });
        }
        if (this.NoSelection) {
            this.NoSelection.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.NoToShare = evt.value;
                console.log(_this.NoToShare);
                if (_this.NoToShare === "NO") {
                    _this.showDisplayView("declined");
                }
                if (_this.NoToShare === "YES") {
                    var Sa_Id = _this.element.querySelector(".SA-ID-wrapper");
                    if (Sa_Id) {
                        Sa_Id.classList.remove("form__group--hidden");
                    }
                    _this.showDisplayView("");
                }
            }); });
        }
        if (this.queryTypeCompliments) {
            this.queryTypeCompliments.addEventListener("change", function (pEvent) {
                _this.updateComplimentsEmail();
                _this.displayComplaintsProcess();
            });
        }
        if (this.feedbackTypeSelect) {
            this.feedbackTypeSelect.addEventListener("change", function () {
                _this.resetSubSelect();
                _this.resetSubSubSelect();
                _this.populateSubFeedBackType(_this.feedbackTypeSelect.value);
            });
        }
        if (this.feedbackTypeSubSelect) {
            this.feedbackTypeSubSelect.addEventListener("change", function () {
                _this.resetSubSubSelect();
                _this.populateSubSubFeedBackType(_this.feedbackTypeSubSelect.value);
            });
        }
        if (this.feedbackTypeSubSubSelect) {
            this.resetSubSubSelect();
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
            _this.resetForm();
        }, false);
    };
    FormItemComplimentsAndComplaints.prototype.updateComplimentsEmail = function () {
        var _value = this.queryTypeCompliments.value;
        var _email = this.element.querySelector("input[name=email]");
        var _recipient = this.element.querySelector("input[name=recipient]");
        if (_value && _email && _recipient) {
            switch (_value) {
                case "COMPLAINT":
                    _email.value = "Complaints.CustomerRelations@standardbank.co.za";
                    _recipient.value = "Complaints.CustomerRelations@standardbank.co.za";
                    break;
                case "COMPLIMENT":
                    _email.value = "Information@standardbank.co.za";
                    _recipient.value = "Information@standardbank.co.za";
                    break;
                case "SUGGESTION":
                    _email.value = "Information@standardbank.co.za";
                    _recipient.value = "Information@standardbank.co.za";
                    break;
                case "QUERY":
                    _email.value = "Information@standardbank.co.za";
                    _recipient.value = "Information@standardbank.co.za";
                    break;
                default:
                    _email.value = "Information@standardbank.co.za";
                    _recipient.value = "Information@standardbank.co.za";
                    break;
            }
        }
    };
    FormItemComplimentsAndComplaints.prototype.displayComplaintsProcess = function () {
        var _value = this.queryTypeCompliments.value;
        if (this.complaintsProcessLinkContainer) {
            if (_value === 'COMPLAINT') {
                this.complaintsProcessLinkContainer.classList.remove('form__group--hidden');
            }
            else {
                this.complaintsProcessLinkContainer.classList.add('form__group--hidden');
            }
        }
    };
    FormItemComplimentsAndComplaints.prototype.populateFeedbackTypeData = function () {
        this.feedbackTypeData = [{
                name: "Please Select"
            }, {
                name: "Account in Arrears / Legal",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "Credit Card",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Dispute Arrears balance",
                            }, {
                                name: "Debt Collections Agent (Outsourced)",
                            }, {
                                name: "Debt Review",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Payment Arrangement",
                            }, {
                                name: "Received Arrears Communications",
                            }, {
                                name: "Unhappy with Legal process",
                            }, {
                                name: "Unhappy with Standard Bank collections process",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Cheque Account",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Dispute Arrears balance",
                            }, {
                                name: "Debt Collections Agent (Outsourced)",
                            }, {
                                name: "Debt Review",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Payment Arrangement",
                            }, {
                                name: "Received Arrears Communications",
                            }, {
                                name: "Unhappy with Legal process",
                            }, {
                                name: "Unhappy with Standard Bank collections process",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Home Loans",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Dispute Arrears balance",
                            }, {
                                name: "Debt Collections Agent (Outsourced)",
                            }, {
                                name: "Debt Review",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Payment Arrangement",
                            }, {
                                name: "Received Arrears Communications",
                            }, {
                                name: "Unhappy with Legal process",
                            }, {
                                name: "Unhappy with Standard Bank collections process",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Insurance",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Dispute Arrears balance",
                            }, {
                                name: "Debt Collections Agent (Outsourced)",
                            }, {
                                name: "Debt Review",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Payment Arrangement",
                            }, {
                                name: "Received Arrears Communications",
                            }, {
                                name: "Unhappy with Legal process",
                            }, {
                                name: "Unhappy with Standard Bank collections process",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Overdraft",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Dispute Arrears balance",
                            }, {
                                name: "Debt Collections Agent (Outsourced)",
                            }, {
                                name: "Debt Review",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Payment Arrangement",
                            }, {
                                name: "Received Arrears Communications",
                            }, {
                                name: "Unhappy with Legal process",
                            }, {
                                name: "Unhappy with Standard Bank collections process",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Personal Loans",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Dispute Arrears balance",
                            }, {
                                name: "Debt Collections Agent (Outsourced)",
                            }, {
                                name: "Debt Review",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Payment Arrangement",
                            }, {
                                name: "Received Arrears Communications",
                            }, {
                                name: "Unhappy with Legal process",
                            }, {
                                name: "Unhappy with Standard Bank collections process",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Vehicle Asset Finance",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Dispute Arrears balance",
                            }, {
                                name: "Debt Collections Agent (Outsourced)",
                            }, {
                                name: "Debt Review",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Payment Arrangement",
                            }, {
                                name: "Received Arrears Communications",
                            }, {
                                name: "Unhappy with Legal process",
                            }, {
                                name: "Unhappy with Standard Bank collections process",
                            }, {
                                name: "Other",
                            }]
                    }]
            }, {
                name: "Card",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "Applications",
                    }, {
                        name: "Card Delivery / Renewal",
                    }, {
                        name: "Closing of Account",
                    }, {
                        name: "Debit Order",
                    }, {
                        name: "Dispute balance",
                    }, {
                        name: "Documents request not actioned",
                    }, {
                        name: "Fees / Interest / Pricing",
                    }, {
                        name: "International Use",
                    }, {
                        name: "Limit Changes",
                    }, {
                        name: "Other",
                    }]
            }, {
                name: "Fraud",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "ATM Fraud",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Claim declined",
                            }, {
                                name: "Delay in finalising claim",
                            }, {
                                name: "No feedback on Claim lodged",
                            }, {
                                name: "Unhappy with partial payment offered",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Card Fraud",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Claim declined",
                            }, {
                                name: "Delay in finalising claim",
                            }, {
                                name: "No feedback on Claim lodged",
                            }, {
                                name: "Unhappy with partial payment offered",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Online Fraud",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Claim declined",
                            }, {
                                name: "Delay in finalising claim",
                            }, {
                                name: "No feedback on Claim lodged",
                            }, {
                                name: "Unhappy with partial payment offered",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Transactional Fraud",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Claim declined",
                            }, {
                                name: "Delay in finalising claim",
                            }, {
                                name: "No feedback on Claim lodged",
                            }, {
                                name: "Unhappy with partial payment offered",
                            }, {
                                name: "Other",
                            }]
                    }]
            }, {
                name: "Home Loans",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "Access Bond",
                    }, {
                        name: "Applications",
                    }, {
                        name: "Assurance",
                    }, {
                        name: "Attorney",
                    }, {
                        name: "Building Loan",
                    }, {
                        name: "Closing / Cancelling of Home Loan",
                    }, {
                        name: "Debit Order",
                    }, {
                        name: "Dispute balance",
                    }, {
                        name: "Documents request not actioned",
                    }, {
                        name: "Fees / Interest / Pricing",
                    }, {
                        name: "Progress payments",
                    }, {
                        name: "Other",
                    }]
            }, {
                name: "Insurance",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "Claim declined",
                    }, {
                        name: "Delay in finalising claim",
                    }, {
                        name: "No feedback on Claim lodged",
                    }, {
                        name: "Unhappy with Claim outcome",
                    }, {
                        name: "Other",
                    }]
            }, {
                name: "Investment / Savings",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "Applications",
                    }, {
                        name: "Closing of Account",
                    }, {
                        name: "Debit Order",
                    }, {
                        name: "Dispute balance",
                    }, {
                        name: "Documents request not actioned",
                    }, {
                        name: "Fees / Interest / Pricing",
                    }, {
                        name: "Funds not in investment account",
                    }, {
                        name: "Poor advice on investment",
                    }, {
                        name: "Other",
                    }]
            }, {
                name: "Standard Executors and Trustees",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "Closing of Account",
                    }, {
                        name: "Delay in finalising of estate",
                    }, {
                        name: "Delay in receiving feedback",
                    }, {
                        name: "Delay in receiving payment",
                    }, {
                        name: "Delay in terminating matter",
                    }, {
                        name: "Dispute with Trustee decisions",
                    }, {
                        name: "Distribution Payments Outstanding",
                    }, {
                        name: "Wills",
                    }, {
                        name: "Other",
                    }]
            }, {
                name: "Transactional",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "Access Loan",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Applications / Sales",
                            }, {
                                name: "Closing of Account",
                            }, {
                                name: "Debit Order",
                            }, {
                                name: "Dispute balance",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Fees / Interest / Pricing",
                            }, {
                                name: "Forex",
                            }, {
                                name: "Inward / Outward Payments",
                            }, {
                                name: "Limit Changes",
                            }, {
                                name: "Reversal / Refund not actioned",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Cheque Account",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Applications / Sales",
                            }, {
                                name: "Closing of Account",
                            }, {
                                name: "Debit Order",
                            }, {
                                name: "Dispute balance",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Fees / Interest / Pricing",
                            }, {
                                name: "Forex",
                            }, {
                                name: "Inward / Outward Payments",
                            }, {
                                name: "Limit Changes",
                            }, {
                                name: "Reversal / Refund not actioned",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "International Payments",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Applications / Sales",
                            }, {
                                name: "Closing of Account",
                            }, {
                                name: "Debit Order",
                            }, {
                                name: "Dispute balance",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Fees / Interest / Pricing",
                            }, {
                                name: "Forex",
                            }, {
                                name: "Inward / Outward Payments",
                            }, {
                                name: "Limit Changes",
                            }, {
                                name: "Reversal / Refund not actioned",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Overdraft",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Applications / Sales",
                            }, {
                                name: "Closing of Account",
                            }, {
                                name: "Debit Order",
                            }, {
                                name: "Dispute balance",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Fees / Interest / Pricing",
                            }, {
                                name: "Forex",
                            }, {
                                name: "Inward / Outward Payments",
                            }, {
                                name: "Limit Changes",
                            }, {
                                name: "Reversal / Refund not actioned",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Personal Loans",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Applications / Sales",
                            }, {
                                name: "Closing of Account",
                            }, {
                                name: "Debit Order",
                            }, {
                                name: "Dispute balance",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Fees / Interest / Pricing",
                            }, {
                                name: "Forex",
                            }, {
                                name: "Inward / Outward Payments",
                            }, {
                                name: "Limit Changes",
                            }, {
                                name: "Reversal / Refund not actioned",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Revolving Credit Plan",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Applications / Sales",
                            }, {
                                name: "Closing of Account",
                            }, {
                                name: "Debit Order",
                            }, {
                                name: "Dispute balance",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Fees / Interest / Pricing",
                            }, {
                                name: "Forex",
                            }, {
                                name: "Inward / Outward Payments",
                            }, {
                                name: "Limit Changes",
                            }, {
                                name: "Reversal / Refund not actioned",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Savings Account",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Applications / Sales",
                            }, {
                                name: "Closing of Account",
                            }, {
                                name: "Debit Order",
                            }, {
                                name: "Dispute balance",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Fees / Interest / Pricing",
                            }, {
                                name: "Forex",
                            }, {
                                name: "Inward / Outward Payments",
                            }, {
                                name: "Limit Changes",
                            }, {
                                name: "Reversal / Refund not actioned",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Student Loan",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Applications / Sales",
                            }, {
                                name: "Closing of Account",
                            }, {
                                name: "Debit Order",
                            }, {
                                name: "Dispute balance",
                            }, {
                                name: "Documents request not actioned",
                            }, {
                                name: "Fees / Interest / Pricing",
                            }, {
                                name: "Forex",
                            }, {
                                name: "Inward / Outward Payments",
                            }, {
                                name: "Limit Changes",
                            }, {
                                name: "Reversal / Refund not actioned",
                            }, {
                                name: "Other",
                            }]
                    }]
            }, {
                name: "Vehicle and Asset Finance",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "Applications / Sales",
                    }, {
                        name: "Closing of Account",
                    }, {
                        name: "Debit Order",
                    }, {
                        name: "Dispute balance",
                    }, {
                        name: "Documents request not actioned",
                    }, {
                        name: "Fees / Interest / Pricing",
                    }, {
                        name: "Insurance added to instalment",
                    }, {
                        name: "Reversal / Refund not actioned",
                    }, {
                        name: "Unhappy with dealer/vehicle",
                    }, {
                        name: "Other",
                    }]
            }, {
                name: "Digital Banking",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "Internet Banking (IB)",
                    }, {
                        name: "Standard Bank App (App)",
                    }, {
                        name: "My-Updates (SMS)",
                    }]
            }, {
                name: "Service Related",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "Branch",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Staff Behaviour",
                            }, {
                                name: "Staff Knowledge",
                            }, {
                                name: "Premises",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Contact Centre",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Staff Behaviour",
                            }, {
                                name: "Staff Knowledge",
                            }, {
                                name: "Premises",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Private Banking",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Staff Behaviour",
                            }, {
                                name: "Staff Knowledge",
                            }, {
                                name: "Premises",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Prestige Banking",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Staff Behaviour",
                            }, {
                                name: "Staff Knowledge",
                            }, {
                                name: "Premises",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Standard Bank Insurance Brokers",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Staff Behaviour",
                            }, {
                                name: "Staff Knowledge",
                            }, {
                                name: "Premises",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Business Banking",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Staff Behaviour",
                            }, {
                                name: "Staff Knowledge",
                            }, {
                                name: "Premises",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Liberty",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Staff Behaviour",
                            }, {
                                name: "Staff Knowledge",
                            }, {
                                name: "Premises",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Stanlib",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Staff Behaviour",
                            }, {
                                name: "Staff Knowledge",
                            }, {
                                name: "Premises",
                            }, {
                                name: "Other",
                            }]
                    }, {
                        name: "Forex",
                        children: [{
                                name: "Please Select"
                            }, {
                                name: "Staff Behaviour",
                            }, {
                                name: "Staff Knowledge",
                            }, {
                                name: "Premises",
                            }, {
                                name: "Other",
                            }]
                    }]
            }, {
                name: "ATM",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "ATM Maintenance",
                    }, {
                        name: "Claim declined",
                    }, {
                        name: "Delay in finalising claim",
                    }, {
                        name: "Deposit not reflecting / retracted",
                    }, {
                        name: "No feedback on Claim lodged",
                    }, {
                        name: "Other Bank ATM",
                    }, {
                        name: "Withdrawal not received / short paid",
                    }, {
                        name: "Other",
                    }]
            }, {
                name: "Unwarranted Marketing",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "Did not request marketing",
                    }, {
                        name: "Request to update personal details not actioned",
                    }, {
                        name: "Receiving calls",
                    }, {
                        name: "Other",
                    }]
            }, {
                name: "UCount Rewards",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "Ucount card not linked",
                    }, {
                        name: "Ucount points balance incorrect",
                    }, {
                        name: "Ucount points not calculated correctly",
                    }, {
                        name: "Ucount registration",
                    }, {
                        name: "Ucount tier not updated",
                    }, {
                        name: "Other",
                    }]
            }, {
                name: "Standard Bank Mobile",
                children: [{
                        name: "Please Select"
                    }, {
                        name: "Sim Card",
                    }, {
                        name: "Phone"
                    }, {
                        name: "Fixed LTE"
                    }, {
                        name: "Other"
                    }]
            }, {
                name: "Personal Lending",
                children: [{
                        name: "Please Select"
                    },
                    {
                        name: 'Application'
                    }, {
                        name: "Closing/Cancelling loan/ Settlement"
                    }, {
                        name: "Debit Order"
                    }, {
                        name: "Fees/Interest/Pricing"
                    }, {
                        name: "Dispute Balance"
                    }, {
                        name: "Revolving Loan"
                    }, {
                        name: "Term Loan"
                    }, {
                        name: "Overdraft"
                    }, {
                        name: "Other"
                    }]
            }];
    };
    FormItemComplimentsAndComplaints.prototype.populateFeedBackType = function () {
        var _this = this;
        if (this.feedbackTypeSelect && this.feedbackTypeData) {
            this.feedbackTypeSelect.innerHTML = "";
            this.feedbackTypeData.map(function (pFeedback) {
                var elem = _this.createOption(pFeedback);
                _this.feedbackTypeSelect.appendChild(elem);
            });
        }
    };
    FormItemComplimentsAndComplaints.prototype.populateSubFeedBackType = function (pEvent) {
        var _this = this;
        if (pEvent === void 0) { pEvent = null; }
        if (pEvent === "") {
            this.resetSubSelect();
            this.resetSubSubSelect();
        }
        else {
            if (this.feedbackTypeSubSelect && this.feedbackTypeData) {
                this.feedbackTypeSubSelect.innerHTML = "";
                var _feedbackSub = this.feedbackTypeData.find(function (PFeedback) {
                    if (PFeedback.name === pEvent) {
                        return PFeedback;
                    }
                });
                if (_feedbackSub && (_feedbackSub.children.length > 0)) {
                    _feedbackSub.children.map(function (pCity) {
                        var elem = _this.createOption(pCity);
                        _this.feedbackTypeSubSelect.appendChild(elem);
                        _this.feedbackTypeSubSelect.classList.remove("form__input--required");
                        var _formGroup = _this.feedbackTypeSubSelect.closest(".form__group");
                        _formGroup.classList.remove("form__group--hidden");
                    });
                }
                else {
                    this.resetSubSelect();
                    this.resetSubSubSelect();
                }
            }
            else {
                this.resetSubSelect();
                this.resetSubSubSelect();
            }
        }
    };
    FormItemComplimentsAndComplaints.prototype.populateSubSubFeedBackType = function (pEvent) {
        var _this = this;
        if (pEvent === void 0) { pEvent = null; }
        if (pEvent === "") {
            this.resetSubSubSelect();
        }
        else {
            if (this.feedbackTypeSubSubSelect && this.feedbackTypeData) {
                this.feedbackTypeSubSubSelect.innerHTML = "";
                var _feedbackSub = this.feedbackTypeData.find(function (PFeedback) {
                    if (PFeedback.name === _this.feedbackTypeSelect.value) {
                        return PFeedback;
                    }
                });
                if (_feedbackSub && (_feedbackSub.children.length > 0)) {
                    var _subSub = _feedbackSub.children.find(function (PFeedback) {
                        if (PFeedback.name === pEvent) {
                            return PFeedback;
                        }
                    });
                    if (_subSub && (_subSub.children.length > 0)) {
                        _subSub.children.map(function (pCity) {
                            var elem = _this.createOption(pCity);
                            _this.feedbackTypeSubSubSelect.appendChild(elem);
                            _this.feedbackTypeSubSubSelect.classList.remove("form__input--required");
                            var _formGroup = _this.feedbackTypeSubSubSelect.closest(".form__group");
                            _formGroup.classList.remove("form__group--hidden");
                        });
                    }
                    else {
                        this.resetSubSubSelect();
                    }
                }
                else {
                    this.resetSubSubSelect();
                }
            }
            else {
                this.resetSubSubSelect();
            }
        }
    };
    FormItemComplimentsAndComplaints.prototype.resetSubSelect = function () {
        if (this.feedbackTypeSubSelect) {
            this.feedbackTypeSubSelect.innerHTML = "";
            var elem = document.createElement("option");
            elem.textContent = "Please select feedback type";
            elem.value = "";
            this.feedbackTypeSubSelect.appendChild(elem);
            this.feedbackTypeSubSelect.classList.add("form__input--required");
            var _formGroup = this.feedbackTypeSubSelect.closest(".form__group");
            _formGroup.classList.add("form__group--hidden");
        }
    };
    FormItemComplimentsAndComplaints.prototype.resetSubSubSelect = function () {
        if (this.feedbackTypeSubSubSelect) {
            this.feedbackTypeSubSubSelect.innerHTML = "";
            var elem = document.createElement("option");
            elem.textContent = "Please select feedback type";
            elem.value = "";
            this.feedbackTypeSubSubSelect.appendChild(elem);
            this.feedbackTypeSubSubSelect.classList.remove("form__input--required");
            var _formGroup = this.feedbackTypeSubSubSelect.closest(".form__group");
            _formGroup.classList.add("form__group--hidden");
        }
    };
    FormItemComplimentsAndComplaints.prototype.createOption = function (pData) {
        var elem = document.createElement("option");
        elem.textContent = pData.name;
        if (pData.name !== "Please Select") {
            elem.value = pData.name;
        }
        else {
            elem.value = "";
        }
        return elem;
    };
    FormItemComplimentsAndComplaints.prototype.submitForm = function (pForm) {
        var _this = this;
        var _subject = this.form.querySelector("input[name=subject]");
        var _recipient = this.form.querySelector("input[name=recipient]");
        var _email = this.form.querySelector("input[name=email]");
        var _feedbackType = this.form.querySelector("select[name=feedback-type]");
        var _productFeedback = this.form.querySelector("select[name=product-feedback]");
        var _productFeedbackCat = this.form.querySelector("select[name=product-feedback-category]");
        var _productFeedbackSubCat = this.form.querySelector("select[name=product-feedback-sub-category]");
        var _userTitle = this.form.querySelector("select[name=user-title]");
        var _firstname = this.form.querySelector("input[name=name]");
        var _lastName = this.form.querySelector("input[name=surname]");
        var _saIdNum = this.form.querySelector("input[name=sa-identity-number]");
        var _contactNumber = this.form.querySelector("input[name=contact-number]");
        var _alternateContactNumber = this.form.querySelector("input[name=alternate-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _isSBCustomer = this.isSBCustomerValue;
        var _textAreaMessage = this.form.querySelector("textarea[name=message]");
        var _popiaConsent = this.form.querySelector("input[name=popia-consent]");
        var _postData = {
            'subject': (_subject ? _subject.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'email': (_email ? _email.value : ""),
            'feedback-type': (_feedbackType ? _feedbackType.value : ""),
            'product-feedback': (_productFeedback ? _productFeedback.value : ""),
            'product-feedback-category': (_productFeedbackCat ? _productFeedbackCat.value : ""),
            'product-feedback-sub-category': (_productFeedbackSubCat ? _productFeedbackSubCat.value : ""),
            'user-title': (_userTitle ? _userTitle.value : ""),
            'name': (_firstname ? _firstname.value : ""),
            'surname': (_lastName ? _lastName.value : ""),
            'sa-identity-number': (_saIdNum ? _saIdNum.value : ""),
            'contact-number': (_contactNumber ? _contactNumber.value : ""),
            'alternate-number': (_alternateContactNumber ? _alternateContactNumber.value : ""),
            'email-address': (_emailAddress ? _emailAddress.value : ""),
            'existing-customer': (_isSBCustomer ? _isSBCustomer : ""),
            'message': (_textAreaMessage ? _textAreaMessage.value : ""),
            'popiConsent': ((_popiaConsent ? (_popiaConsent.checked ? "YES" : "NO") : "NO")),
            'recaptchaToken': this.gRecaptchaToken
        };
        this.showDisplayView("loader");
        // variables
        var url = "/sites/services/SubmitApplicationCCForm.jsp";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData), _config).then(function (pResponse) {
            // service ok
            if (!pResponse) {
                _this.analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
                _this.showDisplayView("error");
            }
            else if (pResponse.data) {
                if (pResponse.data.toString().toLowerCase().includes("invalid")) {
                    _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                    _this.showDisplayView("error");
                }
                else if (pResponse.data.captchaResponse != null && pResponse.data.captchaResponse == false) {
                    _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                    _this.showDisplayView("error");
                }
                else {
                    _this.analyticsService.dtmFormComplete('complete', pResponse.data);
                    _this.showDisplayView("success");
                }
            }
            else {
                _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                _this.showDisplayView("error");
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    // -- CUSTOM BUSINESS CASH SOLUTIONS VALIDATIONS -- //
    FormItemComplimentsAndComplaints.prototype.businessCashSolutionsValidations = function () {
        var radioDetailsErrorDetails = "This field is required";
        var validationErrors = false;
        // Radio Details Selection Error
        var isSBCustomerSelectionGroup = this.isSBCustomer[0].closest(".form__group");
        // Buy Own Details Selection Error
        if (!isSBCustomerSelectionGroup.classList.contains("form__group--hidden")) {
            if (this.isSBCustomerValue === "") {
                validationErrors = true;
                isSBCustomerSelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioDetailsErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                isSBCustomerSelectionGroup.appendChild(_errorDiv);
            }
        }
    };
    FormItemComplimentsAndComplaints.prototype.resetForm = function () {
        this.isSBCustomerValue = 'NO';
        if (this.complaintsProcessLinkContainer) {
            this.complaintsProcessLinkContainer.classList.add('form__group--hidden');
        }
        this.NoToShare = "";
        var Sa_Id = this.element.querySelector(".SA-ID-wrapper");
        if (Sa_Id) {
            Sa_Id.classList.add("form__group--hidden");
        }
        this.showDisplayView("");
    };
    FormItemComplimentsAndComplaints.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        this.displayDeclined.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            case "declined":
                this.displayDeclined.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemComplimentsAndComplaints;
}(Base));
export { FormItemComplimentsAndComplaints };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-compliments-and-complaints/form-item-compliments-and-complaints.component.ts
// module id = 883
// module chunks = 0